var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"statistics elevation-5 ma-0 dark-blue rounded",attrs:{"tile":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',{staticClass:"pa-0 pt-3"},[_c('v-card-text',[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.dateTime)+" - "+_vm._s(_vm.data.message))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }